<template>
    <div class='all'>
        <router-view></router-view>
        <div class='left' style="width: 25%;margin-left: 2vh">
            <div class='logo'>
                <img src="./image/other/logo2.png" height="80" style="margin-top: 30px">
            </div>
            <div class='right2'>
                <p class="alltittle" style="text-align: left">有毒动物样本汇总</p>
                <div id="main" style="height: 32vh; margin-left: -60px"></div>
            </div>
            <div class='right3'>
                <p class="alltittle" style="text-align: left">有毒动物图片展示</p>
                <div class="block">
                    <el-carousel indicator-position="none">
                        <el-carousel-item v-for="(item, index) in items" :key="index">
                            <img :src="item.image" alt="" class="carousel-item-image" height="300" width="300"
                                 style="margin-left: 5vh">
                        </el-carousel-item>
                    </el-carousel>
                </div>
            </div>
            <div class="list-container" style="margin-top: 4vh">
                <p class="alltittle" style="text-align: left">有毒动物样本信息</p>
                <div class="page-example3" style="font-size: 24px; color:lightblue; font-family: 微软雅黑; margin-left: 0.8vw; ">
                    <div class="tittle" style="font-weight: bold">
                        <div>样本编号</div>
                        <div>物种名称</div>
                        <div>采样地点</div>
                    </div>
                    <vue-seamless-scroll class="sro" :data="allSampleSummary" :class-option="defaultOption">
                        <ul class="ul-scoll sro">
                            <li v-for="(item, index) in allSampleSummary" :key='index'>
                                <div class="tittle tittle1" style="margin-left: 0.8vw; height: 40px; line-height: 40px; font-size: 18px">
                                    <div style="text-align: left">{{ item.number }}</div>
                                    <div style="text-align: left">{{ item.species }}</div>
                                    <div style="text-align: left">{{ item.address }}</div>
                                </div>
                            </li>
                        </ul>
                    </vue-seamless-scroll>
                </div>
            </div>
        </div>
        <div class='middle' ref="middle" style="width:50%; margin-left: 2vw">
            <div class='middle1'>
                <div class="hover" @click="page1">
                    <p style="font-size:35px; margin-top: 15px">序列总库</p>
                    <p style="font-size:35px;margin-top: 20px">{{ tbaseInfo.total }}</p>
                </div>
                <div class="hover" @click="page2">
                    <p style="font-size:35px; margin-top: 15px">多肽库</p>
                    <p style="font-size:35px;margin-top: 20px">{{ tbaseInfo.toxin }}</p>
                </div>
                <div class="hover" @click="page3">
                    <p style="font-size:35px; margin-top: 15px">毒素库</p>
                    <p style="font-size:35px;margin-top: 20px">{{ tbaseInfo.toxinTwo }}</p>
                </div>
                <div class="hover" @click="page4">
                    <p style="font-size:35px; margin-top: 15px">实体库</p>
                    <p style="font-size:35px;margin-top: 20px">{{ tbaseInfo.entity }}</p>
                </div>
            </div>
            <div class="middle2" ref="chinaMap"></div>
            <div class='middle3'>
                <div id="basic_dashboard" style="width: 20vh;height: 20vh; margin-top: 50px"></div>
                <div id="basic_dashboard2" style="width: 20vh;height: 20vh; margin-top: 50px"></div>
                <div id="basic_dashboard3" style="width: 20vh;height: 20vh; margin-top: 50px"></div>
            </div>
        </div>
        <div class='right' style="width: 25%; margin-left: 2vw">
            <div class='right1'>
                <p style="font-size:30px">{{ FormatTime(nowTime) }}</p>
                <p style="font-size:30px;margin-top: 10px">{{ FormatTime2(nowTime) }}</p>
            </div>
            <div class='right2'>
                <p class="alltittle" style="text-align: left">适应症及靶点</p>
                <img class='image' src="./image/other/indications.png" style="text-align: right; height: 24vh; margin-left: 1.8vh">
            </div>
            <div class='right3'>
                <p class="alltittle" style="text-align: left">多肽3D结构展示</p>
                <div style="margin-left: 10vh">
                    <el-carousel indicator-position="none">
                        <el-carousel-item v-for="(item, index) in items2" :key="index">
                            <img :src="item.image" alt="" class="carousel-item-image" height="300" width="300">
                        </el-carousel-item>
                    </el-carousel>
                </div>
            </div>
            <div class="list-container" style="margin-top: 4vh">
                <p class="alltittle" style="text-align: left">实体库多肽序列信息表</p>
                <div class="page-example3" style="font-size: 24px; color:lightblue; font-family: 微软雅黑">
                    <div class="tittle" style="margin-left: 0.8vw; font-weight: bold">
                        <div>序列编号</div>
                        <div>化学式</div>
                        <div style="margin-left: 60px">分子量</div>
                    </div>

                    <vue-seamless-scroll class="sro" :data="entityLibList" :class-option="defaultOption">
                        <ul class="ul-scoll sro">
                            <li v-for="(item, index) in entityLibList" :key='index'>
                                <div class="tittle tittle1" style="margin-left: 0.8vw; height: 40px; line-height: 40px; font-size: 18px">
                                    <div style="text-align: left">{{ item.serialNumber }}</div>
                                    <div style="text-align: left; width: 250px">{{ item.chemicalFormula }}</div>
                                    <div style="text-align: left;">{{ item.molecularWeight }}</div>
                                </div>
                            </li>
                        </ul>
                    </vue-seamless-scroll>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import API from '../src/plugins/axiosInstance'
import vueSeamlessScroll from 'vue-seamless-scroll'
import 'echarts/map/china.js'

export default {
    data() {
        return {
            tbaseInfo: {},
            sampleSummaryList: [],
            allSampleSummary: [],
            entityLibList: [],
            nameList: [],
            valueList: [],
            cpu2: 1,
            memory: 1,
            disk: 1,
            nameAndValueVOList: [],
            timer: undefined,
            nowTime: new Date(),
            latedata: "2020-1-9",
            items: [
                {
                    image: require('./image/animals/1.png'),
                },
                {
                    image: require('./image/animals/2.png'),
                },
                {
                    image: require('./image/animals/3.png'),
                },
                {
                    image: require('./image/animals/4.png'),
                },
                {
                    image: require('./image/animals/5.png'),
                },
                {
                    image: require('./image/animals/6.png'),
                },
              {
                image: require('./image/animals/7.png'),
              },
              {
                image: require('./image/animals/8.png'),
              },
              {
                image: require('./image/animals/9.png'),
              },
              {
                image: require('./image/animals/10.png'),
              },
              {
                image: require('./image/animals/11.png'),
              },
              {
                image: require('./image/animals/12.png'),
              },
              {
                image: require('./image/animals/13.png'),
              },
              {
                image: require('./image/animals/14.png'),
              },
              {
                image: require('./image/animals/15.png'),
              },
              {
                image: require('./image/animals/16.png'),
              },
              {
                image: require('./image/animals/17.png'),
              },
              {
                image: require('./image/animals/18.png'),
              },
              {
                image: require('./image/animals/19.png'),
              },
              {
                image: require('./image/animals/20.png'),
              },
              {
                image: require('./image/animals/21.png'),
              },
              {
                image: require('./image/animals/22.png'),
              },
              {
                image: require('./image/animals/23.png'),
              },
              {
                image: require('./image/animals/24.png'),
              },
              {
                image: require('./image/animals/25.png'),
              },
              {
                image: require('./image/animals/26.png'),
              },
              {
                image: require('./image/animals/27.png'),
              },
              {
                image: require('./image/animals/28.png'),
              },
              {
                image: require('./image/animals/29.png'),
              },
              {
                image: require('./image/animals/30.png'),
              },
              {
                image: require('./image/animals/31.png'),
              },
              {
                image: require('./image/animals/32.png'),
              },
            ],
            items2: [
                {
                    image: require('./image/gif/HNYT087_10.gif'),
                },
                {
                    image: require('./image/gif/HNYT087_12.gif'),
                },
                {
                    image: require('./image/gif/HNYT087_13.gif'),
                },
                {
                    image: require('./image/gif/HNYT087_14.gif'),
                }, {
                    image: require('./image/gif/HNYT087_16.gif'),
                },
                {
                    image: require('./image/gif/HNYT087_17.gif'),
                },
                {
                    image: require('./image/gif/HNYT087_18.gif'),
                },
                {
                    image: require('./image/gif/HNYT087_19.gif'),
                },
                {
                    image: require('./image/gif/HNYT087_20.gif'),
                }, {
                    image: require('./image/gif/HNYT087_21.gif'),
                }
            ],
        }
    },
    components: {
        vueSeamlessScroll
    },
    // 监听属性 类似于data概念
    computed: {
        mapSize() {
            return this.$refs.middle.clientWidth;
        },
        defaultOption() { // 设置表格滚动的参数
            return {
                step: 0.5, // 数值越大速度滚动越快
                limitMoveNum: 2000, // 开始无缝滚动的数据量 this.dataList.length
                hoverStop: true, // 是否开启鼠标悬停stop
                direction: 1, // 0向下 1向上 2向左 3向右
                openWatch: true, // 开启数据实时监控刷新dom
                singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
                singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
                waitTime: 3000 // 单步运动停止的时间(默认值1000ms)
            }
        }

    },
    created() {
        // 显示时间，在渲染页面之前一直调用该函数，对this.time进行赋值
        this.timer = setInterval(() => {
            this.nowTime = new Date().toLocaleString();
        }, 1000);
        //设置执行时间 一般1秒执行一次
        this.getDate()
    },
    // 销毁定时器
    beforeDestroy() {
        if (this.timer) {
            clearInterval(this.timer);
        }
    },
    mounted() {
    },
    methods: {
        getDate() {
            API({
                url: '/dashboard/getDate',
                method: 'get',
            }).then(
                response => {
                    this.tbaseInfo = response.data.tbaseInfo;
                    this.nameList = response.data.nameList;
                    this.valueList = response.data.valueList;
                    this.sampleSummaryList = response.data.sampleSummaryList;
                    this.allSampleSummary = response.data.allSampleSummary;
                    this.entityLibList = response.data.entityLibList;
                    this.nameAndValueVOList = response.data.nameAndValueVOList;
                    this.$nextTick(() => {
                        this.basic_dashboard_type()
                        this.basic_dashboard_type2()
                        this.basic_dashboard_type3()
                        this.getmain()
                        this.initCharts()
                        // this.showTime()
                    })
                }
            ).catch(function () {
            })
        },
        page1() {
            this.$router.push({
                path: '/page1'
            })
        },
        page2() {
            this.$router.push({
                path: '/page2'
            })
        },
        page3() {
            this.$router.push({
                path: '/page3'
            })
        },
        page4() {
            this.$router.push({
                path: '/page4'
            })
        },
        basic_dashboard_type() {
            const chartDom = document.getElementById('basic_dashboard');
            const myChart = this.$echarts.init(chartDom);
            var option = {
                series: [{"type": 'gauge',
                    enter: ['50%', '60%'],
                    startAngle: 180,
                    endAngle: 0,
                    min: 0,
                    max: 100,
                    splitNumber: 10,
                    itemStyle: {"color": '#b5e19b'},
                    progress: {"show": true,"width": 10 },
                    pointer: {"show": false},
                    axisLine: {"lineStyle": {"width": 10}},
                    axisTick: {"distance": -20,
                    splitNumber:5,
                    lineStyle:{"width": 1,
                    color: '#999'}},
                    splitLine:{"distance": -25,
                    length: 10,
                    lineStyle:{"width": 2,"color":'#999'}},
                    axisLabel: {"distance": -10,
                    color: '#999',
                    fontSize: 12},
                    anchor: {"show": false},
                    title: {"show": false},
                    detail: {"valueAnimation": true,
                    width: '60%',
                    lineHeight: 100,
                    borderRadius: 8,
                    offsetCenter: [0, '-15%'],
                    fontSize: 20,
                    fontWeight: 'bolder',
                    formatter: "{value}%"+'CPU',
                    color: 'inherit',
                    fontStyle:"微软雅黑",
            },
                    data: [{"name":"使用率(%)",
                        value: this.tbaseInfo.cpu,
                    }]
                }
                ]
            }
            myChart.setOption(option);
        },
        basic_dashboard_type2() {
            var chartDom = document.getElementById('basic_dashboard2');
            var myChart = this.$echarts.init(chartDom);
            var option = {
                series: [{"type": 'gauge',
                    enter: ['50%', '60%'],
                    startAngle: 180,
                    endAngle: 0,
                    min: 0,
                    max: 100,
                    splitNumber: 10,
                    itemStyle: {"color": '#b5e19b'},
                    progress: {"show": true,"width": 10 },
                    pointer: {"show": false},
                    axisLine: {"lineStyle": {"width": 10}},
                    axisTick: {"distance": -20,
                        splitNumber:5,
                        lineStyle:{"width": 1,
                            color: '#999'}},
                    splitLine:{"distance": -25,
                        length: 10,
                        lineStyle:{"width": 2,"color":'#999'}},
                    axisLabel: {"distance": -10,
                        color: '#999',
                        fontSize: 12},
                    anchor: {"show": false},
                    title: {"show": false},
                    detail: {"valueAnimation": true,
                        width: '60%',
                        lineHeight: 100,
                        borderRadius: 8,
                        offsetCenter: [0, '-15%'],
                        fontSize: 20,
                        fontWeight: 'bolder',
                        formatter: "{value}%"+'内存',
                        color: 'inherit',
                        fontStyle:"微软雅黑",
                    },
                    data: [{"name":"使用率(%)",
                        value: this.tbaseInfo.memory,
                    }]
                }
                ]
            }
            myChart.setOption(option);
        },
        basic_dashboard_type3() {
            var chartDom = document.getElementById('basic_dashboard3');
            var myChart = this.$echarts.init(chartDom);
            var option = {
                series: [{"type": 'gauge',
                    enter: ['50%', '60%'],
                    startAngle: 180,
                    endAngle: 0,
                    min: 0,
                    max: 100,
                    splitNumber: 10,
                    itemStyle: {"color": '#b5e19b'},
                    progress: {"show": true,"width": 10 },
                    pointer: {"show": false},
                    axisLine: {"lineStyle": {"width": 10}},
                    axisTick: {"distance": -20,
                        splitNumber:5,
                        lineStyle:{"width": 1,
                            color: '#999'}},
                    splitLine:{"distance": -25,
                        length: 10,
                        lineStyle:{"width": 2,"color":'#999'}},
                    axisLabel: {"distance": -10,
                        color: '#999',
                        fontSize: 12},
                    anchor: {"show": false},
                    title: {"show": false},
                    detail: {"valueAnimation": true,
                        width: '60%',
                        lineHeight: 100,
                        borderRadius: 8,
                        offsetCenter: [0, '-15%'],
                        formatter: "{value}%"+'硬盘',
                        color: 'inherit',
                        fontStyle:"微软雅黑",
                    },
                    data: [{"name":"使用率(%)",
                        value: this.tbaseInfo.disk,
                    }]
                }
                ]
            }

            myChart.setOption(option);
        },
        getmain() {
            var chartDom = document.getElementById('main');
            var myChart = this.$echarts.init(chartDom);
            var option = {
                grid: {
                    left: '20%',
                    top: '5%'
                },
                yAxis: {
                    type: 'category',
                    data: this.nameList,
                    axisLabel: {
                        textStyle: {
                            color: '#fff',
                            fontSize: 16
                        }
                    },
                },
                xAxis: {
                    splitLine: {
                        show: false
                    },
                    axisLabel: {
                        margin:400,
                        interval:5,
                        width: 300,
                        height: 300,
                        overflow: 'truncate',
                        align: 'left',
                        textStyle: {
                            color: '#fff',
                            // fontSize: 300,
                        },
                    }
                },
                series: [
                    {
                        type: 'bar',
                        data: this.valueList,
                        itemStyle: {
                            normal: {
                                color: function(params) {
                                    var colorList = ["#6cb0da","#73727f"];
                                    return colorList[params.dataIndex % 2];
                                },
                                label: {
                                    show:true,
                                    position:'right',
                                    valueAnimation: true,
                                    color:'white',
                                    textStyle: {
                                        fontSize:12
                                    }
                                }
                            },

                            barBorderRadius: 5,
                            borderWidth: 1.5,
                            borderType: 'solid',
                            shadowBlur: 3
                        }
                    }
                ],
                tooltip: {
                    trigger: 'item',  //数据项图形触发
                    backgroundColor: "#fff",
                    borderWidth: 0,
                    formatter: '动物：{b}<br/>数据：{c}'
                },
            }
            myChart.setOption(option);
        },
        initCharts() {
            let mapcharts = this.$echarts.init(this.$refs.chinaMap);
            //窗口尺寸改变
             window.addEventListener("resize",function(){
               mapcharts.resize();
             })

            // 绘制图表
            mapcharts.setOption({
                grid: {
                    top: 50
                },
                series: [{
                    type: 'map',
                    map: 'china',
                    layoutCenter: ['45%', '50%'], // 地图布局中心点
                    layoutSize: 1200,
                    label: {
                        show: false,
                        color: '#000000',
                        fontSize: 10,
                    },
                    itemStyle: {
                        areaColor: "lightskyblue",
                        borderColor: "#404a59"
                    },
                    roam: false,
                    zoom: 0.8,
                    emphasis: {
                        label: {
                            color: '#fff',
                            fontSize: 12,
                            fontWeight: 'bold'
                        },
                        itemStyle: {
                            areaColor: 'none',
                            borderColor: '#77ebff',
                            borderWidth: 2
                        }
                    },
                    data: this.nameAndValueVOList
                }],
                visualMap: [{
                    type: 'continuous',
                    show: true,
                    pieces: [
                        {min: 0, max: 10},
                        {min: 11, max: 50},
                        {min: 51, max: 100},
                        {min: 100},
                    ],
                    textStyle: {
                        color: '#fff',
                    },
                    itemWidth: 20, // 每个图元的宽度
                    itemHeight: 100,
                    right: "150",
                    bottom: "280",
                    marginRight: "50",
                    inRange: {
                        // borderRadius: 1,
                        'color': ['#80bc74', '#FF5733', 'red'] // 绘图区颜色
                    },
                }],
                tooltip: {
                    trigger: 'item',  //数据项图形触发
                    backgroundColor: "#fff",
                    borderWidth: 0,
                    formatter: '地区：{b}<br/>数据：{c}'
                },
            });
        },
        FormatTime() {
            //返回显示的日期时间格式
            var date = new Date();
            var year = this.formatTime(date.getFullYear());
            var month = this.formatTime(date.getMonth() + 1);
            var day = this.formatTime(date.getDate());
            var weekday = date.getDay();
            var weeks = new Array(
                "星期日",
                "星期一",
                "星期二",
                "星期三",
                "星期四",
                "星期五",
                "星期六"
            );
            var week = weeks[weekday];
            return `${year}-${month}-${day} ${week}`;
        },
        FormatTime2() {
            //返回显示的日期时间格式
            var date = new Date();
            var hour = this.formatTime(date.getHours());
            var minute = this.formatTime(date.getMinutes());
            var second = this.formatTime(date.getSeconds());
            return `${hour}:${minute}:${second}`;
        },
        formatTime(n) {
            //判断是否需要加0
            if (n < 10) {
                return "0" + n;
            } else {
                return n;
            }
        }
    }
}
</script>

<style scoped>
.all {
    width: 100%;
    overflow: hidden;
    background-repeat: no-repeat;
    background-image: url('./image/other/background.png');
    background-size: 100% 100%;
    display: flex; /* 使用Flexbox布局 */
    padding: 0;
    margin: 0;
    justify-content: space-between; /* 控制子元素间隔 */
    color: white;
    height: calc(100%);
    min-width: 1920px;
}

.logo {
    margin-left: 20px;
}

.hover:hover {
    background-color: #185ce4;
}

.right1 {
    margin-top: 50px;
    margin-right: 50px;
    height: 5vh;
}

.right2 {
    margin-top: 20px;
    height: 350px;
}

.right2 > img {
    display: block;
    margin-top: 1vh;
    height: calc(100% - 1.94vh - 1vh);
    width: 100%;
}

.right3 {
    margin-top: 10px;
    box-sizing: border-box;
    padding-top: 0.925vh;
    height: 350px;
}

.right3 > img {
    display: block;
    margin-top: 1vh;
    height: calc(100% - 1.94vh - 1vh);
    width: 100%;
}

.middle1 {
    display: flex; /* 使用Flexbox布局 */
    padding: 20px;
    justify-content: space-between; /* 控制子元素间隔 */
    margin-right: 50px;
    margin-top: 15px;
    color: white;
    height: 7vh;
}
.middle2{
    height: 68vh;
}

.middle3 {
    display: flex; /* 使用Flexbox布局 */
    padding: 15px;
    justify-content: space-between; /* 控制子元素间隔 */
    height: 25vh;
    margin-bottom: 0px;
}

.list-container {
    height: 450px;
}

.sro {
    margin-top: 1.94vh;
    height: 25vh;
    overflow-y: hidden;
}

.page-example3, .page-example3 ul {
    height: 3000px;
    box-sizing: border-box;
    padding: 1vh 0;
}

.page-example3 ul {
    overflow-y: hidden;
}

.tittle {
    height: 1.94vh;
    display: flex;
    align-items: center;
    justify-content: center;
}

.tittle > div {
    width: 33.3333333%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.tittle1 {
    height: 4vh;
}

.tittle1 > div {
    height: 4vh;
    line-height: 4vh;
    text-align: center;
}

.alltittle {
    color: #b5e19b;
    font-size:2.4vh;
    font-family: 微软雅黑;
    font-weight: bold;
    margin-left: 20px;
}

.el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 150px;
    margin: 0;
}

.el-carousel__item:nth-child(2n) {
}

.el-carousel__item:nth-child(2n+1) {
}

p {
    margin: 0px;
    height: 1.94vh;
    font-size: 1.94vh;
    line-height: 1.94vh;
    text-align: center;
}

ul {
    list-style: none;
}
</style>
